export interface LectureData {
  id?: string | number;
  batchId?: number;
  eventName?: string;
  startTime?: string;
  endTime?: string;
  syllabusStatus?: string;
  updatedByEmail?: string;
  updatedAt?: string;
  eventLink?: string;
  batchName?: string;
  subject?: string;
  fexRecordId?: number;
  courseId?: number;
  branchId?: string;
  class?: string;
  batchTimeTableId?: number;
  alcLecture?: boolean;
  attendanceStatus?: string | null;
  documentsS3Key?: string | null;
  eventCode?: string;
  eventType?: string | undefined;
  lectureContent?: {
    videos?: {
      url: string;
      client: string;
    }[];
    ebooks?: {
      id: number;
      url: string;
      assetType: string;
      createdAt: number;
      client: string;
    }[];
  };
  markLecture?: boolean;
  msTeamsMeetingUrl?: string | null;
  revisionRank?: number;
  room?: string;
  syllabusList?: string;
  takeAttendance?: boolean;
  updatedByName?: string | null;
}

const EVENT_TYPES_WITH_NAMES = ["LECTURE", "EXTRA CLASS"];

export const getLectureHeading = (lecture: LectureData): string => {
  const eventType = lecture.eventType?.trim() || "";
  const eventName = lecture.eventName?.trim() || "";

  if (EVENT_TYPES_WITH_NAMES.includes(eventType.toUpperCase())) {
    return eventName || eventType;
  }

  return eventType || eventName;
};
